import { Navigate, useParams, useSearchParams } from "react-router-dom";
import type { Rig } from "../../lib/bookingApi";

function isRig(value: string | undefined): value is Rig {
  return value === "commodore" || value === "serenity";
}

const Book = () => {
  const { rig: rigParam } = useParams();
  const [searchParams] = useSearchParams();
  const queryRig = searchParams.get("rental");

  const next = new URLSearchParams(searchParams);
  next.delete("rental");
  const qs = next.toString();
  const suffix = qs ? `?${qs}` : "";

  const rig =
    (queryRig && isRig(queryRig) && queryRig) ||
    (isRig(rigParam) && rigParam) ||
    "commodore";

  return <Navigate to={`/fleet/${rig}${suffix}`} replace />;
};

export default Book;
